import { useEffect, useState } from 'react';
import { useStore } from '@hmpu/powerups.store';
import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { useTranslate } from '@hmpu/powerups.intl.legacy.hooks.use-translate';
import { CTAButton } from '@hmpu/powerups.ui.buttons.cta-button';
import { globalizedMedia } from '@hmpu/powerups.intl.hooks.use-localized-media';
import './Disclaimer.css';
import useResetFocus from '../../hooks/useResetFocus';
import HeaderH1 from '../../components/Promo';

export const Disclaimer = ({ pageData, goToNextPage }) => {
  const parentNode = 'DISCLAIMER';
  const translate = useTranslate();
  const { __t } = useTranslation('DISCLAIMER');
  const bgImg = translate('bgImg', parentNode);
  const pageTitle = translate('pageTitle', parentNode);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const inPortrait = useStore((state) => state.inPortrait);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const setSkipTarget = useStore((state) => state.setSkipTarget);
  const setBackTarget = useStore((state) => state.setBackTarget);
  const logo = globalizedMedia(translate('logoImg', parentNode), 'img');
  const warningTextBg = globalizedMedia(translate('warningHeaderBg', parentNode), 'img');
  const hmButton = translate("hmButton", parentNode);

  const [calloutA11y1, setCalloutA11y1] = useState('');
  const [calloutA11y2, setCalloutA11y2] = useState('');

  useEffect(() => {
    const calloutText = __t('callout-a11y');
    const parts = calloutText.split('\n');
    setCalloutA11y1(parts[0]);
    setCalloutA11y2(parts[1] || '');
  }, [])

  useEffect(() => {
    setPageTitle(pageTitle);
  }, [showSettingsPanel, inPortrait, isPauseEnabled]);
  
  // useResetFocus();

  useEffect(() => {
    setBackTarget(null);
    setSkipTarget(null);
  }, [setBackTarget, setSkipTarget]);

  return (
    <section className="disclaimer-page"
      style={{
        // backgroundImage: `url(${bgImg})`,
      }}
    >
      <div className="disclaimer-copy">
        <img
          src={logo}
          alt={translate('logoImgAlt', parentNode)}
          className="disclaimer-logo-img"
        />

        <div className="disclaimer-h2s">
          <h1 className='DisclaimerH1'>{__t('warning')}</h1>
          <p className='HeaderH2'>{__t('header')}</p>
          <p className='HeaderH2'>{calloutA11y1}</p>
          <p className='HeaderH2'>{calloutA11y2}</p>        
        </div>

        <div className="disclaimer-cta-container">
          <ul className="disclaimer-ctas">
            <li>
              <CTAButton
                primary
                onClick={(evt) => {
                  document
                    .querySelectorAll('video')
                    .forEach((player) => player.play());
                  goToNextPage(evt);
                }}
                intlKey={'button'}
                parentNode={parentNode}
              />
            </li>
            <li>
              <CTAButton
                role="link"
                onClick={
                  () => {
                    window.location.href = hmButton.url;
                  }
                }
                intlKey={'hmButton'}
                parentNode={parentNode}
              />
            </li>
          </ul>
        </div>
      </div>
      <div className="copyright-notice">
          <p className='copyright-notice-text'
            dangerouslySetInnerHTML={{ __html: __t('copyright') }}
          ></p>
      </div>
    </section>
  );
};

export default Disclaimer;
